import React, { useEffect, useState } from "react";
import { fetchTree, buildTopicChildrenMap } from "./quiz3Utils";

// Duyệt cây subject -> topic -> topic con (TQ-01 / QA-01), dùng chung cho
// cả màn hình Làm bài (chọn node để xem đề) và Soạn câu hỏi (chọn node để
// gắn câu hỏi/đề). manageMode=true hiện thêm nút "+ môn học"/"+ chủ đề".
// checkable=true: hiện checkbox trước mỗi dòng (subject/topic) để chọn nhiều
// node cùng lúc (vd "Mở bài kiểm tra" bên HappySchool chọn nhiều chủ đề) —
// checkedKeys là Set các nodeKey đã tích, onToggleCheck(nodeKey) gọi khi tích/bỏ.
const Quiz3TreeBrowser = ({ selectedKey, onSelectNode, manageMode, onAddSubject, onAddTopic, reloadKey, checkable, checkedKeys, onToggleCheck }) => {
  const [subjects, setSubjects] = useState({});
  const [topics, setTopics] = useState({});
  const [expanded, setExpanded] = useState({});

  useEffect(() => {
    let cancelled = false;
    fetchTree()
      .then((data) => {
        if (cancelled) return;
        setSubjects(data.subjects || {});
        setTopics(data.topics || {});
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [reloadKey]);

  const byParent = buildTopicChildrenMap(topics);

  const toggle = (key) => setExpanded((e) => ({ ...e, [key]: !e[key] }));

  const renderTopicRow = (subjectId, topic, depth) => {
    const nodeKey = `topic:${topic.id}`;
    const isExpanded = !!expanded[nodeKey];
    const hasChildren = (byParent[topic.id] || []).length > 0;
    const isSelected = selectedKey === nodeKey;
    return (
      <div key={topic.id}>
        <div style={rowStyle(isSelected, depth)}>
          <span
            onClick={() => hasChildren && toggle(nodeKey)}
            style={{ width: 16, display: "inline-block", cursor: hasChildren ? "pointer" : "default" }}
          >
            {hasChildren ? (isExpanded ? "▾" : "▸") : ""}
          </span>
          {checkable && (
            <input
              type="checkbox"
              checked={checkedKeys.has(nodeKey)}
              onChange={() => onToggleCheck(nodeKey)}
              style={{ marginRight: 2, cursor: "pointer" }}
            />
          )}
          <span onClick={() => (checkable ? onToggleCheck(nodeKey) : onSelectNode(subjectId, topic.id))} style={labelStyle} title={topic.name}>
            {topic.name}
          </span>
          {manageMode && (
            <button style={smallBtnStyle} onClick={() => onAddTopic(subjectId, topic.id)}>
              + chủ đề con
            </button>
          )}
        </div>
        {isExpanded && (byParent[topic.id] || []).map((child) => renderTopicRow(subjectId, child, depth + 1))}
      </div>
    );
  };

  return (
    <div className="quiz3-tree" style={{ fontSize: 14, textAlign: "left" }}>
      {/* .grid-container > div ở App.css ép text-align: center !important, với độ đặc hiệu
          (0,1,1) — cao hơn ".quiz3-tree *" (0,1,0), nên phải nhân đôi class ở đây
          (0,2,0) mới thắng được, thứ tự nạp CSS không quyết định khi cả 2 đều !important. */}
      <style>{`
        .quiz3-tree.quiz3-tree, .quiz3-tree.quiz3-tree * {
          text-align: left !important;
        }
      `}</style>
      {manageMode && (
        <button style={{ ...smallBtnStyle, marginBottom: 12 }} onClick={onAddSubject}>
          + Thêm môn học
        </button>
      )}
      {Object.entries(subjects).length === 0 && (
        <p style={{ color: "#6b7280" }}>Chưa có môn học nào{manageMode ? " — bấm \"+ Thêm môn học\" để tạo." : "."}</p>
      )}
      {Object.entries(subjects).map(([subjectId, subject]) => {
        const nodeKey = `subject:${subjectId}`;
        const isExpanded = !!expanded[nodeKey];
        const isSelected = selectedKey === nodeKey;
        const rootTopics = byParent[`root:${subjectId}`] || [];
        return (
          <div key={subjectId} style={{ marginBottom: 4 }}>
            <div style={rowStyle(isSelected, 0)}>
              <span
                onClick={() => rootTopics.length > 0 && toggle(nodeKey)}
                style={{ width: 16, display: "inline-block", cursor: rootTopics.length > 0 ? "pointer" : "default" }}
              >
                {rootTopics.length > 0 ? (isExpanded ? "▾" : "▸") : ""}
              </span>
              {checkable && (
                <input
                  type="checkbox"
                  checked={checkedKeys.has(nodeKey)}
                  onChange={() => onToggleCheck(nodeKey)}
                  style={{ marginRight: 2, cursor: "pointer" }}
                />
              )}
              <strong onClick={() => (checkable ? onToggleCheck(nodeKey) : onSelectNode(subjectId, null))} style={labelStyle} title={subject.name}>
                {subject.name}
              </strong>
              {manageMode && (
                <button style={smallBtnStyle} onClick={() => onAddTopic(subjectId, null)}>
                  + chủ đề
                </button>
              )}
            </div>
            {isExpanded && rootTopics.map((topic) => renderTopicRow(subjectId, topic, 1))}
          </div>
        );
      })}
    </div>
  );
};

const rowStyle = (selected, depth) => ({
  display: "flex",
  alignItems: "center",
  gap: 6,
  padding: "4px 8px",
  marginLeft: depth * 18,
  borderRadius: 6,
  background: selected ? "#eff6ff" : "transparent",
});

const labelStyle = {
  cursor: "pointer",
  flex: 1,
  minWidth: 0, // cần cho ellipsis hoạt động trong flex
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis", // tên dài -> cắt bằng dấu "..."
};

const smallBtnStyle = {
  fontSize: 12,
  padding: "2px 8px",
  border: "1px solid #d1d5db",
  borderRadius: 6,
  background: "#fff",
  cursor: "pointer",
};

export default Quiz3TreeBrowser;
